import { useTranslations } from '@vocab/react';
import { Box, Heading, Stack, Text, Inline } from 'braid-design-system';
import React, { type ComponentProps, type ReactNode } from 'react';
import { Element } from 'react-scroll';

import translations from './.vocab';

type HeadingLevel = ComponentProps<typeof Heading>['level'];

interface Props {
  children: ReactNode;
  heading?: string;
  headingLevel?: HeadingLevel;
  isOptional?: boolean;
  sectionName?: string;
  subHeading?: string;
  testId?: string;
  intercomId?: string;
}

export const PageSection = ({
  children,
  heading,
  headingLevel = '3',
  isOptional,
  sectionName = '',
  subHeading,
  testId = '',
  intercomId,
}: Props) => {
  const { t } = useTranslations(translations);

  return (
    <Element
      id={sectionName}
      name={sectionName}
      data-testid={testId}
      data-intercomid={intercomId ?? sectionName}
    >
      <Stack space="small">
        <Inline alignY="bottom" space="xxsmall">
          {heading ? <Heading level={headingLevel}>{heading}</Heading> : null}
          {isOptional ? (
            <Text tone="secondary">({t('page-section-optional-text')})</Text>
          ) : null}
        </Inline>
        {subHeading ? <Text tone="secondary">{subHeading}</Text> : null}
      </Stack>
      <Box marginBottom={heading ? 'large' : 'none'} />
      {children}
    </Element>
  );
};
